import {Icon} from 'leaflet';

const defaultAttribute = {
    iconUrl : '',
    iconSize : [30, 30], // size of the icon
    iconAnchor : [22, 94], // point of the icon which will correspond to marker's location
    popupAnchor : [-3, -76] // point from which the popup should open relative to the iconAnchor    
}

export const DefaultIcon = new Icon (Object.assign(
    {
        iconUrl : require("../../assets/images/mapIcons/marker-icon-2x.png"),
        iconSize : [30, 40],
        iconAnchor : [22, 110]
    }
))

export const AutumnIcon = new Icon (Object.assign(
    defaultAttribute,{iconUrl : require("../../assets/images/mapIcons/autumn.png")}
))

export const SpringIcon = new Icon (Object.assign(
    defaultAttribute,{iconUrl : require("../../assets/images/mapIcons/spring.png")}
))

export const SummerIcon = new Icon (Object.assign(
    defaultAttribute,{iconUrl : require("../../assets/images/mapIcons/summer.png")}
))

export const WinterIcon = new Icon (Object.assign(
    defaultAttribute,{iconUrl : require("../../assets/images/mapIcons/winter.png")}
))
export const AutumnActiveIcon = new Icon (Object.assign(
    defaultAttribute,{iconUrl : require("../../assets/images/mapIcons/autumn_active.png")}
))

export const SpringActiveIcon = new Icon (Object.assign(
    defaultAttribute,{iconUrl : require("../../assets/images/mapIcons/spring_active.png")}
))

export const SummerActiveIcon = new Icon (Object.assign(
    defaultAttribute,{iconUrl : require("../../assets/images/mapIcons/summer_active.png")}
))

export const WinterActiveIcon = new Icon (Object.assign(
    defaultAttribute,{iconUrl : require("../../assets/images/mapIcons/winter_active.png")}
))

export const HistoryIcon = new Icon (Object.assign(
    {
        iconUrl : require("../../assets/images/mapIcons/history.png"),
        iconSize : [20, 25],
        iconAnchor : [9, 22],
        className: "icon-red"
    }
))
export const StationIcon = new Icon (Object.assign(
    {
        iconUrl : require("../../assets/images/mapIcons/train-icon.png"),
        iconSize : [25, 25],
        iconAnchor : [9, 22],
    }
))
export const RestaurantIcon = new Icon (Object.assign(
    {
        iconUrl : require("../../assets/images/mapIcons/food-icon.png"),
        iconSize : [25, 25],
        iconAnchor : [9, 22],
    }
))
export const ElevatorIcon = new Icon (Object.assign(
    {
        iconUrl : "/assets/images/mapIcons/elevator.svg",
        iconSize : [30, 30],
        iconAnchor : [9, 22],
    }
))
export const ToiletIcon = new Icon (Object.assign(
    {
        iconUrl : "/assets/images/mapIcons/toilet.svg",
        iconSize : [30, 30],
        iconAnchor : [9, 22],
    }
))
export const SlopeIcon = new Icon (Object.assign(
    {
        iconUrl : "/assets/images/mapIcons/slope.svg",
        iconSize : [30, 30],
        iconAnchor : [9, 22],
    }
))